import { Icon } from '@iconify/react';
import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Div from '../Div';
import PageHeading from '../PageHeading';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import ContactInfoWidget from '../Widget/ContactInfoWidget';

export default function ContactPage() {
  pageTitle('Contact Us');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <PageHeading
        title="Contact Us"
        bgSrc="/images/contact_hero_bg.jpeg"
        pageLinkText="Contact"
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-6">
            <SectionHeading
              title="Do you have a project <br/>in your mind?"
              subtitle="Get In Touch"
            />
            <Spacing lg="55" md="30" />
            <ContactInfoWidget withIcon />
            <Spacing lg="30" md="20" />
            <Div style={{ display: 'flex', gap: 15, flexWrap: 'wrap' }}>
              <a
                href="https://wa.me/971544905157"
                target="_blank"
                rel="noreferrer"
                className="cs-btn cs-style1"
                style={{ display: 'inline-flex', fontSize: 14 }}
              >
                <span><Icon icon="fa6-brands:whatsapp" style={{ marginRight: 8, fontSize: 16, verticalAlign: 'middle' }} />WhatsApp</span>
                <Icon icon="bi:arrow-right" />
              </a>
              <a
                href="https://www.linkedin.com/company/codewus"
                target="_blank"
                rel="noreferrer"
                className="cs-btn cs-style1"
                style={{ display: 'inline-flex', fontSize: 14 }}
              >
                <span><Icon icon="fa6-brands:linkedin-in" style={{ marginRight: 8, fontSize: 16, verticalAlign: 'middle' }} />LinkedIn</span>
                <Icon icon="bi:arrow-right" />
              </a>
            </Div>
            <Spacing lg="0" md="50" />
          </Div>
          <Div className="col-lg-6">
            <form action="#" className="row">
              <Div className="col-sm-6">
                <label className="cs-primary_color">First Name*</label>
                <input type="text" className="cs-form_field" placeholder="First Name" />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Last Name*</label>
                <input type="text" className="cs-form_field" placeholder="Last Name" />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Email*</label>
                <input type="email" className="cs-form_field" placeholder="example@email.com" />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-6">
                <label className="cs-primary_color">Phone*</label>
                <input type="tel" className="cs-form_field" placeholder="+971 XX XXX XXXX" />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-12">
                <label className="cs-primary_color">Company</label>
                <input type="text" className="cs-form_field" placeholder="Company name" />
                <Spacing lg="20" md="20" />
              </Div>
              <Div className="col-sm-12">
                <label className="cs-primary_color">Message*</label>
                <textarea
                  cols="30"
                  rows="7"
                  className="cs-form_field"
                  placeholder="Tell us about your project..."
                ></textarea>
                <Spacing lg="25" md="25" />
              </Div>
              <Div className="col-sm-12">
                <button className="cs-btn cs-style1">
                  <span>Send Message</span>
                  <Icon icon="bi:arrow-right" />
                </button>
              </Div>
            </form>
          </Div>
        </Div>
      </Div>
      <Spacing lg="150" md="80" />
      <Div className="cs-google_map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3611.695714731393!2d55.14544867538996!3d25.07481493685168!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6c8fe5e51433%3A0x471cfbba5d5fac4f!2sJumeirah%20Lakes%20Towers%20-%20Cluster%20P%2C%20Sheikh%20Zayed%20Rd%20-%20Al%20Thanyah%20Fifth%20-%20Dubai!5e0!3m2!1sen!2sae!4v1700000000001!5m2!1sen!2sae"
          allowFullScreen
          title="CodeWus Office - Dubai"
        />
      </Div>
      <Spacing lg="50" md="40" />
    </>
  );
}
